import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as OfferParametersActions from './tyre-offer-parameters.action';
import { TyreOfferParametersService } from './tyre-offer-parameters.service';
import { BannerService } from '../../shared/services/banner.service';
import * as OfferParametersModels from '../../models/tyre-offer-parameters/tyre-offer-parameters';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { saveAs } from 'file-saver';


export interface OfferParametersStateModel {
    Save: SaveState;
    Parameters: OfferParametersModels.TyreOfferParameterModel[];
  }

@State<OfferParametersStateModel>({
    name: 'tyreOfferParametersState',
    defaults: {
      Save: null,
      Parameters: null
    }
  })

  @Injectable()
  export class TyreOfferParametersState {

    constructor(
      private helperService: HelperService,
      private offerParametersService: TyreOfferParametersService,
      private bannerService: BannerService
  ) { }


  @Selector()
  static Save(state: OfferParametersStateModel) {
    return state.Save;
  }

  @Selector()
  static Parameters(state: OfferParametersStateModel) {
    return state.Parameters;
  }


  @Action(OfferParametersActions.Set)
  set(
    context: StateContext<OfferParametersStateModel>,
    action: OfferParametersActions.Set
  ) {
      const state = context.getState();
      const errorMessage = `Błąd zapisu parametrów.`;


      this.offerParametersService.set(action.Params).subscribe((ret) => {
          this.bannerService.success(`Parametry zostały zapisane.`);

          context.setState(
            patch({
              Save: new SaveState(action.Version, true)
            })
          );

        },

        (error) => {
          context.setState(
            patch({
              Save: new SaveState(action.Version, false)
            })
          );

          this.helperService.SaveException('OfferParametersActions.Set', error);
          this.bannerService.error(errorMessage);
        });

  }

  @Action(OfferParametersActions.Get)
  get(
    context: StateContext<OfferParametersStateModel>,
    action: OfferParametersActions.Get
  ) {
      const state = context.getState();
      const errorMessage = `Błąd odczytu parametrów.`;


      this.offerParametersService.get().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Parameters: ret.Items
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }

        },

        (error) => {
          context.setState(
            patch({
              Parameters: null
            })
          );

          this.helperService.SaveException('OfferParametersActions.Set', error);
          this.bannerService.error(errorMessage);
        });

  }


}
